module.exports = __webpack_public_path__ + "../resources/img/text_confirm.f9413aba.png";